// @flow
import React from 'react';
import { VirtualTours } from 'components/organisms/virtualTours';
import { VirtualToursMobile } from 'components/organisms/virtualToursMobile';
import { useViewport } from 'components/templates/viewportProvider';
import type { VirtualTour } from 'types/project';

type Props = {
  data: {
    data: Array<VirtualTour>,
  },
};

export const VirtualTourSection = (props: Props) => {
  const { height, isMobile } = useViewport();
  const { data } = props.data;
  if (!data || data.length === 0) {
    return null;
  }

  const onExploreClick = () => {
    props.fullpageApi && props.fullpageApi.moveSectionDown();
  };

  return (
    <div key={'virtual-tours'} style={{ height }} id={'virtual-tours'}>
      {isMobile ? (
        <VirtualToursMobile tours={data} onExploreClick={onExploreClick} />
      ) : (
        <VirtualTours tours={data} onExploreClick={onExploreClick} />
      )}
    </div>
  );
};
